// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2jz6c","bigColWidth":"Table_bigColWidth__guFgl","biggerColWidth":"Table_biggerColWidth__1zTqr","row":"Table_row__28MRK","col":"Table_col__2BUGn"};